import { css } from '@emotion/react'
import { Card, colors } from 'plume-ui'
import { useUser } from '../../../contexts/AuthContext'
import { isEnterpriseWithTrial, isLatestPlan } from '@/lib/user'
import { COMPANIES_PER_PAGE } from '../../../pages/investors/[shortname]'
import { CompanyData } from '../../../types/api'
import { CardInnerTitle } from '../../atoms/CardInnerTitle'
import { LoadingOverlay } from '../../atoms/LoadingOverlay'
import { Table } from '../../atoms/Table'
import { Pagination } from '../../common/Pagination'
import { CompaniesTableBody } from '../../common/table/CompaniesTableBody'
import { CompaniesTableHead } from '../../common/table/CompaniesTableHead'
import { DownloadButton } from './molecules/DownloadButton'
import { EmptyCard } from '../../common/EmptyCard'
import React from 'react'

type Props = {
  companies: CompanyData[] | undefined
  tableRef: React.MutableRefObject<null>
  loading: boolean
  page: number
  count: number
  handleChangePage: (page: number) => void
  downloading: boolean
  handleDownload: () => void
}

export const DomesticInvestmentTable: React.FC<Props> = ({
  companies,
  tableRef,
  loading,
  page,
  count,
  handleChangePage,
  downloading,
  handleDownload,
}) => {
  const user = useUser()
  return (
    <Card>
      <CardInnerTitle
        className="domestic-invested-table-title"
        title="スタートアップ"
      >
        {isEnterpriseWithTrial(user) && companies?.length ? (
          <DownloadButton
            hasPermission={isEnterpriseWithTrial(user) && isLatestPlan(user)}
            isLoading={downloading}
            onClick={handleDownload}
            css={css`
              margin-left: auto;
            `}
          />
        ) : undefined}
      </CardInnerTitle>
      {companies?.length ? (
        <div ref={tableRef}>
          <Table className="domestic-invested-table">
            <CompaniesTableHead
              withTotalFunding={isEnterpriseWithTrial(user)}
            />
            <CompaniesTableBody
              withTotalFunding={isEnterpriseWithTrial(user)}
              items={companies}
            />
          </Table>
          <LoadingOverlay active={loading} />
          <div
            css={css`
              display: flex;
              justify-content: center;
              align-items: center;
              padding-top: 8px;
              padding-bottom: 8px;
              background-color: ${colors.white10};
            `}
            className="domestic-company-pagination"
          >
            <Pagination
              limit={COMPANIES_PER_PAGE}
              count={count}
              page={page}
              setPage={handleChangePage}
            />
          </div>
        </div>
      ) : (
        <EmptyCard />
      )}
    </Card>
  )
}
